import { render, staticRenderFns } from "./MultiChatViewer.vue?vue&type=template&id=416adc89"
import script from "./MultiChatViewer.vue?vue&type=script&lang=js"
export * from "./MultiChatViewer.vue?vue&type=script&lang=js"
import style0 from "./MultiChatViewer.vue?vue&type=style&index=0&id=416adc89&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports